/**
 * iter87.468 — "Watch how it works" modal, reused in the Start a Rivalry
 * flow. Wraps the same IntroVideo element the landing page uses so the
 * video file/poster are the single shared source.
 */
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Dialog, DialogPortal, DialogOverlay } from "@/components/ui/dialog";
import { X } from "lucide-react";
import IntroVideo from "./IntroVideo";

export default function IntroVideoModal({ open, onOpenChange }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogPortal>
                <DialogOverlay />
                <DialogPrimitive.Content
                    className="fixed left-[50%] top-[50%] z-50 w-[92vw] sm:w-full max-w-2xl translate-x-[-50%] translate-y-[-50%] focus:outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=open]:duration-200 data-[state=closed]:duration-150"
                    data-testid="intro-video-modal"
                >
                    <DialogPrimitive.Title className="sr-only">
                        How Tiny Crew Rivalries works
                    </DialogPrimitive.Title>
                    <div className="relative">
                        <IntroVideo testId="intro-video-modal-player" />
                        <DialogPrimitive.Close
                            data-testid="intro-video-modal-close"
                            className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-cyber border-2 border-black flex items-center justify-center text-black hover:bg-cyber/90 focus:outline-none"
                        >
                            <X className="w-4 h-4" strokeWidth={2.5} />
                            <span className="sr-only">Close</span>
                        </DialogPrimitive.Close>
                    </div>
                </DialogPrimitive.Content>
            </DialogPortal>
        </Dialog>
    );
}
